export default __webpack_public_path__ + "static/media/I0007.d7995817.png";